module.exports = __webpack_public_path__ + "static/img/wz-p1.97f7ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wz-p1.png
// module id = FXYC
// module chunks = 1